import config from '@/config/prod.env';
import header from '@/helper/header';
import common from '@/helper/common';

const mainUrl = `${process.env.VUE_APP_API_URL}/UserWorkspace`;

export default {      
    getByWorkspaceIdAndUserIds: async (workspaceId, userIds) => {
        const requestOptions = {
            method: 'POST',
            headers: await header.authHeaderWithToken(),
            body: JSON.stringify({ 
                "workspaceId": workspaceId,
                "userIds": userIds
            })
        };
    
        let rs = await fetch(`${mainUrl}/GetByWorkspaceIdAndUserIds`, requestOptions);
        return await common.handleResponse(rs);
    },
    
    createMultiple: async (body) => {
        var requestOptions = {
            method: 'POST',
            headers: header.authHeaderWithToken(),
            body: JSON.stringify(body),
        };
    
        let rs = await fetch(`${mainUrl}/CreateMultiple`, requestOptions);
        return await common.handleResponse(rs);
    },

    deleteByWorkspaceIdAndUserIds: async (workspaceId, userIds) => {
        var requestOptions = {
            method: 'DELETE',
            headers: header.authHeaderWithToken(),
            body: JSON.stringify({
                "workspaceId": workspaceId,
                "userIds": userIds
            }),
        };
    
        let rs = await fetch(`${mainUrl}/DeleteByWorkspaceIdAndUserIds`, requestOptions);
        return await common.handleResponse(rs);
    },
}